import XdcLogo from 'assets/images/xdc-logo.png'
import XdcLogoTest from 'assets/images/xdc-logo-test.png'
import { SupportedChainId } from 'constants/chains'
import useHttpLocations from 'hooks/useHttpLocations'
import { useMemo } from 'react'
import { isAddress } from 'utils'

import { NATIVE_CHAIN_ID } from '../../constants/tokens'

export function getNativeLogoURI(chainId: SupportedChainId = SupportedChainId.XDC): string {
  switch (chainId) {
    case SupportedChainId.XDC:
      return XdcLogo
    case SupportedChainId.XDC_TESTNET:
      return XdcLogoTest
    default:
      return XdcLogo
  }
}

export function getTokenLogoURI(address: string, chainId: SupportedChainId = SupportedChainId.XDC): string | undefined {
  if (chainId === SupportedChainId.XDC || chainId === SupportedChainId.XDC_TESTNET) {
    return `https://raw.githubusercontent.com/XSwapProtocol/xdc-token-list/master/assets/${address}/logo.png`
  }
  return undefined
}

export default function useCurrencyLogoURIs(
  currency:
    | {
        isNative?: boolean
        isToken?: boolean
        address?: string
        chainId: number
        logoURI?: string | null
      }
    | null
    | undefined
): string[] {
  const locations = useHttpLocations(currency?.logoURI)
  return useMemo(() => {
    const logoURIs = [...locations]
    if (currency) {
      if (currency.isNative || currency.address === NATIVE_CHAIN_ID) {
        logoURIs.push(getNativeLogoURI(currency.chainId))
      } else if (currency.isToken || currency.address) {
        const checksummedAddress = isAddress(currency.address)
        const logoURI = checksummedAddress && getTokenLogoURI(checksummedAddress, currency.chainId)
        if (logoURI) {
          logoURIs.push(logoURI)
        }
      }
    }
    return logoURIs
  }, [currency, locations])
}
